<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><a class="a_disabled">协会工作部</a></li> -->
                <li><router-link :to="titleLink">{{ title }}</router-link></li>
                <li class="currentNode"><a>工作部简介</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>{{ title }}</a></li>
                    <li>
                        <router-link :to="`/layout/info-branch-introduction?id=${id}`" class="active">工作部简介</router-link>
                    </li>
                    <li>
                        <router-link :to="`/layout/info-branch-responsibilities?id=${id}`">主要职责</router-link>
                    </li>

                </ul>
                <div class="page-content">
                    <h3>工作部简介</h3>
                    <div class="noContentDetail" v-html="saler" ></div>
                    <!-- <p>信息工作部是经民政部批准成立的跨地区、跨行业、全国性的社团组织，党建工作由国务院国资委管理，业务上接受国家发展改革委等部门指导。</p>
                    <p class="introduction-title">宗旨</p>
                    <p>贯彻节约资源和保护环境基本国策，落实循环经济促进法，依靠广大会员，联系各方力量，发挥协会桥梁纽带作用，为构建覆盖全社会的资源循环利用体系，提高资源利用效率，源头防治环境污染，推进绿色、循环、低碳发展，加快建设生态文明，促进经济绿色转型，建设美丽中国做出积极贡献。</p>
                    <p class="introduction-title">职责</p>
                    <p>为政府制定循环经济发展战略规划，健全法规标准，完善政策机制，推进技术进步，开展示范试点，强化宣传培训，加强监督管理，提供技术支持；为行业、企业和会员单位制定发展规划，编制实施方案，推广先进技术和商业模式，开展项目论证、对接和投融资服务，提供政策、管理、技术、市场等信息咨询服务，反映企业诉求及政策建议，依法依规推动循环经济健康发展。</p>
                    <p class="introduction-title">业务领域</p>
                    <p>推动地区在生产、流通、消费各环节推行循环型生产方式和消费模式，加快建设循环型社会体系。推进循环经济示范城市(县)建设和生态文明示范区建设。</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name: '',
    data() {
        return {
            id: '',
            title: '',
            saler: '',
            titleLink: '',
        }
    },
    created() {
        this.id = this.$route.query.id + '';
        this.traverseTitle();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        traverseTitle() {
            if (this.id === '1'){
                this.title = "信息工作部";
                this.titleLink = '/layout/info-branch-introduction?id=1';
            } else if (this.id === '2'){
                this.title = "双招双引工作部";
                this.titleLink = '/layout/info-branch-introduction?id=2';
            } else if (this.id === '3') {
                this.title = "医药卫生工作部";
                this.titleLink = '/layout/info-branch-introduction?id=3';
            } else {
                this.title = "企业工作部";
                this.titleLink = '/layout/info-branch-introduction?id=4';
            }
        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.saler = res.Data.Saler;
                } else {
                    this.$message.error("工作部简介请求失败");
                }
            })
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
        '$route.query.id': {
            handler: function(toId, fromId){
                this.id = toId;
                this.getXiehuiModel();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}

.page-content h3 {
    text-align: center;
}

.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
}

.association-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.association-item {
    width: 216px;
    height: 116px;
    background: #F3F3F3;
    color: #4E5969;
    font-size: 20px;
    text-align: center;
}
.a_disabled {
    cursor: not-allowed;
}
</style>